import { GetLendingSupportDealFinanceOfferResponse } from '../../hooks/services';

type FinanceResponse =
  GetLendingSupportDealFinanceOfferResponse[number]['financeResponses'][number];

/**
 * Orders finance responses deterministically: oldest first, then by badge,
 * then by ID. The API returns responses in no guaranteed order, and responses
 * created in the same batch share a timestamp.
 */
export const sortFinanceResponses = <T extends FinanceResponse>(
  responses: T[],
): T[] =>
  [...responses].sort(
    (a, b) =>
      (Date.parse(a.createdAt) || 0) - (Date.parse(b.createdAt) || 0) ||
      (a.initialSubmissionData?.primaryBadgeValue ?? '').localeCompare(
        b.initialSubmissionData?.primaryBadgeValue ?? '',
      ) ||
      a.id.localeCompare(b.id),
  );
